import { useCallback, useEffect, useState } from "react";
import { http } from "../lib/api";

export const useMySongs = () => {
  const [songs, setSongs] = useState([]);
  const load = useCallback(() => http.get("/songs/mine").then((r) => setSongs(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  const pending = songs.some((s) => !["completed", "failed"].includes(s.status));
  useEffect(() => {
    if (!pending) return undefined;
    const t = setInterval(load, 3000);
    return () => clearInterval(t);
  }, [pending, load]);
  return { songs, load };
};
